module.exports = __webpack_public_path__ + "img/icone-bolsa-profael.7a16296a.png";